import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* All require auth except for Login */
export default new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  routes: [
    {
      path: '/case/:vars?',
      name: 'start',
      component: () => import('./views/Start.vue')
    },
    {
      path: '/case/status/:status',
      name: 'caseStatus',
      component: () => import('./views/CaseStatus.vue')
    },
    {
      path: '/wizard/:step?',
      name: 'wizard',
      component: () => import('./views/Wizard.vue')
    },
    {
      path: '*',
      name: 'notfound',
      component: () => import('./views/NotFound.vue')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
